import React, { startTransition, useEffect, useState } from "react";
import Button from "Components/shared/button";
import Text from "Components/shared/text";
import styles from "./container.module.css";
import { icons, images } from "assets";
import { InputWithAdornment } from "Components/shared/inputs";
import FormControl from "Components/shared/control";
import Select from "Components/shared/select";
import { useNavigate } from "react-router-dom";
import { Storage } from "utils/clientStorage";

export const QuickTransfer = ({ transaction }) => {
  const navigate = useNavigate();
  const [cards, setCard] = useState(null);

  useEffect(() => {
    let card = Storage.getItem("DEBITCARD");
    setCard(card);
  }, []);
  return (
    <Text tag="div" className={styles.todoContainer}>
      <Text tag="p" style={{ fontWeight: "600" }}>
        Quick Tranfer
      </Text>
      {cards ? (
        <Text tag="div">
          <Text tag="div" style={{ padding: "1rem 0", textAlign: "center" }}>
            <img src={images.oops} alt="OOPS" />
            <Text style={{ paddingTop: "2rem" }}>
              Opps!! Looks like you do not have any benefidiary
            </Text>
          </Text>
          <Button
            label="Add a beneficiary"
            style={{ width: "100%", marginTop: "1.5rem" }}
            onClick={() => startTransition(navigate("/transfer/new-account"))}
          />
        </Text>
      ) : (
        <Text tag="div">
          <FormControl fullWidth style={{ marginTop: "25px", padding: 0 }}>
            <Select options={["One", "two"]} />
          </FormControl>
          <Text tag="div" style={{ margin: "1rem 0" }}>
            <InputWithAdornment
              placeholder="Select wallet to debit"
              right={<img src={icons.ic_human} />}
            />
          </Text>
          <Text tag="div" style={{ margin: "1rem 0" }}>
            <InputWithAdornment placeholder="Account Number" />
          </Text>
          <Text tag="div" style={{ display: "flex" }}>
            <Button
              variant="outlined"
              color="grey"
              fullWidth={true}
              style={{ color: "var(--input-color)" }}
            >
              -
            </Button>
            <Text tag="div" style={{ margin: "0 1rem" }}>
              <InputWithAdornment
                placeholder="Amount"
                style={{ width: "100px" }}
                type="number"
              />
            </Text>
            <Button
              variant="outlined"
              color="grey"
              fullWidth={true}
              style={{ color: "var(--input-color)" }}
            >
              +
            </Button>
          </Text>
          <Button
            label="Send Money"
            style={{ width: "100%", marginTop: "1.5rem" }}
          />
        </Text>
      )}
    </Text>
  );
};
